import { required } from 'vuelidate/lib/validators'

const requiredMsg = 'Обязательное поле'

export default (vars) => {
  return {
    name: {
      required: {
        validator: required,
        message: requiredMsg
      }
    },
    label: {
      required: {
        validator: required,
        message: requiredMsg
      }
    }
  }
}
